import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAuth } from '../lib/auth-context'

const API_URL = import.meta.env.VITE_API_URL || ''

export const Route = createFileRoute('/sign-in')({
  component: SignInPage,
})

function SignInPage() {
  const { isAuthenticated, isLoading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      navigate({ to: '/operator' })
    }
  }, [isAuthenticated, navigate])

  const handleSignIn = () => {
    const redirectTo = encodeURIComponent('/operator')
    window.location.href = `${API_URL}/api/auth/workos/authorize?redirect_to=${redirectTo}`
  }

  const handleDevLogin = () => {
    const redirectTo = encodeURIComponent('/operator')
    window.location.href = `${API_URL}/api/auth/dev/login?redirect_to=${redirectTo}`
  }

  const isDev = import.meta.env.DEV

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-gray-500">Loading...</div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900">Domarcai</h1>
          <p className="mt-2 text-sm text-gray-600">Operator Portal</p>
        </div>

        <div className="mt-8 space-y-3">
          <button
            type="button"
            onClick={handleSignIn}
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500"
          >
            Sign in with WorkOS
          </button>

          {isDev && (
            <button
              type="button"
              onClick={handleDevLogin}
              className="w-full flex justify-center py-3 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500"
            >
              Dev Login (skip WorkOS)
            </button>
          )}
        </div>

        <p className="mt-4 text-center text-xs text-gray-500">
          Secure authentication powered by WorkOS
        </p>
      </div>
    </div>
  )
}
